import { useSelector } from 'react-redux';
import FilterButton from '../../../filter/FilterButton';
import FilterDialog from './Dialog';
import { useEffect } from 'react';
import useFeeds from '../../../../hooks/feed/useFeed';

const FilterButtonFeed = () => {
  const { getFeeds, isLoadingList } = useFeeds();

  const open = useSelector((state) => state?.filter?.feed?.open || false);
  const stateFilter = useSelector((state) => state?.filter?.feed?.filter);
  const rowsPerPage = useSelector((state) => state?.datatable?.feed?.rowsPerPage || 100);
  const skip = useSelector((state) => state?.datatable?.feed?.skip || 0);

  useEffect(() => {
    getFeeds(stateFilter || {}, skip, rowsPerPage);
  }, [rowsPerPage, skip, stateFilter]);

  return (
    <>
      <FilterButton
        module='feed'
        disabled={isLoadingList}
        keysFilter={[
         // 'yearLevelId',
          'rolesId',
          'startDatePusblishedAt',
          'endDatePusblishedAt',
          'startDateExpireAt',
          'endDateExpireAt'
        ]}
      />
      {open && <FilterDialog />}
    </>
  );
};
export default FilterButtonFeed;
